<template>
  <div>
      <button-white v-show="error.status !== 'released'" @click="releaseSchedule">Schreibtisch wieder freigeben</button-white>
      <p v-show="error.status === 'released'" class="border bg-green-300 rounded-full text-center">Schreibtisch wieder freigegeben</p>
  </div>
</template>

<script>
import ButtonWhite from "../components/UI/ButtonWhite";

export default {
    name:"DeleteErrorMessage",

    components: {ButtonWhite},

    props: ['error'],

    methods:{
        releaseSchedule() {
             window.axios.post(`/admin/schedules/${this.error.id}`, {
                 _method: 'put',
                is_resolved: true,
            }).then(() => {
                this.error.status = 'resolved';
                this.$root.$emit('alert', 'Der Schreibtisch ist wieder zur Vermittlung freigegeben.');
                this.$emit('reload');
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        },
    }

}
</script>

<style>

</style>